/* unplugin-vue-components disabled */import script from "./ComplaintInfringementComponents.vue?vue&type=script&setup=true&lang=js"
export * from "./ComplaintInfringementComponents.vue?vue&type=script&setup=true&lang=js"

import "./ComplaintInfringementComponents.vue?vue&type=style&index=0&id=0c6f40a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c6f40a6"]])

export default __exports__